export default __webpack_public_path__ + "static/media/twitter.1a7449c5.png";